import { isC3Experience } from "../../../shared/util/C3Utils";
define((require) => {
    "use strict";

    const Backbone              = require("backbone");
    const Marionette            = require("marionette");
    const _                     = require("underscore");
    const EditorControllerMixin = require("ui/editor/EditorControllerMixin");
    const ExperiencePreview     = require("ui/viewer/ExperiencePreview");
    const LayerEnum             = require("ui/editor/LayerEnum");
    const PreviewNavBarView     = require("ui/viewer/PreviewNavBarView");
    const PreviewTemplateNavBarView     = require("ui/viewer/PreviewTemplateNavBarView");
    const GroupCollection       = require("shared/ui/groups/GroupCollection");
    const TemplateViewModel     = require("editor/ui/viewer/TemplateViewModel");
    const ExperienceViewModel   = require("shared/ui/viewer/ExperienceViewModel");
    const ExperienceURLProvider = require("ui/experience/ExperienceURLProvider");
    const {Logger}                = require("shared/util/Logger");
    const ZoomModel             = require("ui/editor/ZoomModel");

    const logger = new Logger("EditorPreviewController");

    /**
     * Controller for the editor.
     *
     * @author Bo Gotthardt
     * @class EditorController
     * @constructor
     *
     * @cfg {Region} region The main view region, where the editor view should be rendered.
     */
    return Marionette.Controller.extend({

        mixin: [EditorControllerMixin],

        _preview: function(variants = [], experience, options, self, id, layerName, scene, type) {
            const isTemplate = type === ExperienceURLProvider.TYPES.TEMPLATE;

            let viewModel;
            if (isTemplate) {
                viewModel = new TemplateViewModel({
                    // TODO: Would it be OK for the VIEW model to get a cloned experience with an ID?
                    experience: experience.clone(),
                    // The ID is not cloned
                    editorCurrentLayer: LayerEnum.lookup(layerName, LayerEnum.SCENE),
                    templateId: id
                });
            } else {
                viewModel = new ExperienceViewModel({
                    // TODO: Would it be OK for the VIEW model to get a cloned experience with an ID?
                    experience: experience.clone(),
                    // The ID is not cloned
                    experienceId: experience.id,
                    editorCurrentLayer: LayerEnum.lookup(layerName, LayerEnum.SCENE)
                });
            }

            if (scene) {
                viewModel.set("currentScene", scene);
            }

            self.listenTo(viewModel, "change:currentScene", () => {
                const experienceURL = ExperienceURLProvider.provide(id, ExperienceURLProvider.ACTION.PREVIEW, viewModel.get("currentScene"), undefined, type);
                Backbone.history.navigate(experienceURL, {replace: true});
            });

            const zoomModel = new ZoomModel();

            const showViewer = function() {
                options.region.show(new ExperiencePreview({
                    experienceViewModel: viewModel,
                    zoomModel: zoomModel
                }));
            };

            // Display the viewer only once the previous view has closed
            if (options.region.isClosed()) {
                showViewer();
            } else {
                options.region.once("close", showViewer);
                options.region.close();
            }

            const navBarView = type === ExperienceURLProvider.TYPES.EXPERIENCE ?
                PreviewNavBarView : PreviewTemplateNavBarView;

            options.navBarRegion.show(new navBarView({
                model: viewModel,
                zoomModel: zoomModel,
                variants: variants
            }));
        },

        previewTemplate: function(id, scene, layerName) {
            const options = this.options;
            const self = this;

            this._fetchTemplateExperienceAndFonts(id)
                .then((model) => {
                    self._preview(undefined, model, options, self, id, layerName, scene, ExperienceURLProvider.TYPES.TEMPLATE);
                })
                .fail((msg) => {
                    logger.warn(msg);
                    Backbone.history.navigate("", true);
                });
        },

        /**
         * Editor preview an existing experience with the specified ID.
         *
         * @param {String} id The id of the experience to preview.
         * @param {Number} [scene] The optional start scene, defaults to 1.
         * @param layerName
         */
        previewExperience: function(id, scene, layerName) {
            const self = this;
            const options = this.options;
            let experience;

            this._fetchExperienceAndFonts(id)
                .then((model) => {
                    experience = model;

                    return self._fetchVariantDescriptors(experience);
                })
                .then((variants) => {
                    self._preview(variants, experience, options, self, id, layerName, scene, ExperienceURLProvider.TYPES.EXPERIENCE);
                })
                .fail((msg) => {
                    logger.warn(msg);
                    Backbone.history.navigate("", true);
                });
        },

        /**
         * If the specified experience is part of a group, fetch that group and create an array
         * of objects describing those experiences.
         *
         * @param  {ExperienceModel} experience The current experience model.
         * @return {Promise}                    A promise that resolves with an array of descriptors
         *                                       for the <tt>PreviewNavBarView</tt>.
         *
         * @see  PreviewNavBarView
         */
        _fetchVariantDescriptors: function(experience) {
            return GroupCollection
                .byAssetId(experience.get("id"))
                .then((groups) => {
                    const newDashboardExperience = isC3Experience();
                    // PE-1216: New C3-API doesn't have endpoints for groups, hence we define the group as undefined instead of fetching it
                    const group = newDashboardExperience ? undefined : groups.findByAssetId(experience.get("id"));
                    let variants = [];
                    const descriptor = function(entry) {
                        const id = entry[0].get("id");

                        return {
                            groupType: group.getDashedType(),
                            identifier: entry[1] ? entry[1].getIdentifier() : "",
                            id: id,
                            url: "#experience/" + id + "/preview/1"
                        };
                    };

                    if (group) {
                        variants = _.map(group.getUniqueEntries(), descriptor);
                    }

                    return variants;
                });
        }
    }, {
        injection: {
            parameters: ["errorLogger"],
            asOptions: true
        }
    });
});



// WEBPACK FOOTER //
// ./src/editor/ui/editor/EditorPreviewController.js